<template>
  <div class="token-income-source bg--color-01">
    <div class="container-wrapper bg--color-02">
      <div class="token-income-source__container container-new">
        <div class="token-income-source__info">
          <h5
            class="txt--bold txt--36px txt--44px--l txt--height-44px txt--height-58px--l txt--color-04 mb-24 mb-18--l"
          >
            {{ $t('tokenNew.incomeSource.title') }}
          </h5>
          <p
            class="txt--wight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03 mb-18"
            v-html="$t('tokenNew.incomeSource.desc')"
          />
          <ul class="token-income-source__list mb-0">
            <li
              v-for="(item, indx) in $t('tokenNew.incomeSource.list')"
              :key="indx"
            >
              <span
                class="txt--wight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03"
              >
                {{ item }}
              </span>
            </li>
          </ul>
          <button-with-arrow
            class="token-income-source__btn mt-24 mt-18--l"
            :to="localePath('/business')"
            full-width
            size="l"
          >
            {{ $t('welcome.latinAmerica.btn') }}
          </button-with-arrow>
        </div>
        <img
          class="token-income-source__image"
          src="@/assets/img/token/wallet.svg"
          width="100%"
          alt="wallet"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenIncomeSource',
  components: {
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
}
</script>

<style lang="scss" scoped>
.token-income-source {
  &__container {
    display: grid;
    grid-template-areas: 'info' 'image';
    gap: toRem(24px);

    @include bp(m) {
      grid-template-areas: 'image info';
      grid-template-columns: 1fr 1.5fr;
    }

    @include bp(l) {
      gap: toRem(36px);
    }
  }

  &__list {
    list-style: inside;

    li::marker {
      color: color('color-03');
    }
  }

  &__info {
    grid-area: info;

    @include bp(m) {
      margin: auto 0;
    }
  }

  &__btn {
    @include bp(m) {
      width: fit-content;
    }
  }

  &__image {
    grid-area: image;
    max-width: toRem(531px);

    @include bp(0, m) {
      margin: 0 auto;
    }
  }
}
</style>
